import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SuiContainer, SuiTextInput, SuiDropdown, SuiDropdownOption } from '@splashthat/sui';

import { getQuestionFormNodesOfInputType, getQuestionFormNodes } from 'common/entities/formNode/selectors';
import { INPUT_TYPE_DATE, INPUT_TYPE_TIME } from 'common/entities/formNode/inputTypes';

import EditViewSectionContainer from '../EditViewSectionContainer';
import RequiredControl from '../components/RequiredControl';
import SectionSeparator from '../components/SectionSeparator';
import FieldNameControl from '../components/FieldNameControl';
import { updateFormNodeConfigValue } from '../../../actions/nodeActions';
import { getEditFormNodeId, getEditFormNode, getFormId } from '../../../selectors';

const LABEL_CLIENT_ID = 'Client Id';
const LABEL_CLIENT_SECRET = 'Client Secret';
const LABEL_COMPANY_TOKEN = 'Company Token';
const LABEL_START_DATE_QUESTION = 'Start Date Question';
const LABEL_START_TIME_QUESTION = 'Start Time Question';
const LABEL_END_DATE_QUESTION = 'End Date Question';
const LABEL_END_TIME_QUESTION = 'End Time Question';
const LABEL_TIME_ZONE_QUESTION = 'Time Zone Question';
const LABEL_LOCATION_QUESTION = 'Location Question';
const LABEL_WIDGET_URL = 'Widget Url';
const LABEL_RESOURCE_TYPE = 'Resource Type';

const CONFIG_NAME_EVENT_OPS_CLIENT_ID = 'eventOpsClientId';
const CONFIG_NAME_EVENT_OPS_CLIENT_SECRET = 'eventOpsClientSecret';
const CONFIG_NAME_EVENT_OPS_COMPANY_TOKEN = 'eventOpsCompanyToken';
const CONFIG_NAME_START_DATE_NODE_CODE = 'eventOpsStartDateNodeCode';
const CONFIG_NAME_START_TIME_NODE_CODE = 'eventOpsStartTimeNodeCode';
const CONFIG_NAME_END_DATE_NODE_CODE = 'eventOpsEndDateNodeCode';
const CONFIG_NAME_END_TIME_NODE_CODE = 'eventOpsEndTimeNodeCode';
const CONFIG_NAME_TIME_ZONE_NODE_CODE = 'eventOpsTimeZoneNodeCode';
const CONFIG_NAME_LOCATION_NODE_CODE = 'eventOpsLocationNodeCode';
const CONFIG_NAME_EVENT_OPS_WIDGET_URL = 'eventOpsWidgetUrl';
const CONFIG_NAME_EVENT_OPS_RESOURCE_TYPE = 'eventOpsResourceType';

const renderQuestionsForDropdown = (nodes) =>
    nodes.map(({ id, code, label }) => <SuiDropdownOption value={code} key={id} displayValue={label} />);

/**
 * Component for main guest information fields like first name, last name and email.
 */
const EventOps2EditView = (props) => (
    <React.Fragment>
        <RequiredControl />
        <EditViewSectionContainer>
            <SuiContainer variation="flex-group">
                <FieldNameControl formNodeId={props.formNodeId} />
            </SuiContainer>

            <SectionSeparator />

            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={'-'}
                    value={props.eventOpsResourceType}
                    fullWidth
                    label={LABEL_RESOURCE_TYPE}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_EVENT_OPS_RESOURCE_TYPE, value)
                    }
                >
                    <SuiDropdownOption value={'space'} displayValue={'Space'} />
                    <SuiDropdownOption value={'equipment'} displayValue={'Equipment'} />
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiTextInput
                    value={props.eventOpsClientId}
                    fullWidth
                    label={LABEL_CLIENT_ID}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_EVENT_OPS_CLIENT_ID, value)
                    }
                />
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiTextInput
                    value={props.eventOpsClientSecret}
                    fullWidth
                    label={LABEL_CLIENT_SECRET}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_EVENT_OPS_CLIENT_SECRET, value)
                    }
                />
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiTextInput
                    value={props.eventOpsCompanyToken}
                    fullWidth
                    label={LABEL_COMPANY_TOKEN}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_EVENT_OPS_COMPANY_TOKEN, value)
                    }
                />
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={props.dateQuestionNodes.length ? '-' : 'No date questions'}
                    value={props.eventOpsStartDateNodeCode}
                    fullWidth
                    label={LABEL_START_DATE_QUESTION}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_START_DATE_NODE_CODE, value)
                    }
                >
                    {renderQuestionsForDropdown(props.dateQuestionNodes)}
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={props.timeQuestionNodes.length ? '-' : 'No time questions'}
                    value={props.eventOpsStartTimeNodeCode}
                    fullWidth
                    label={LABEL_START_TIME_QUESTION}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_START_TIME_NODE_CODE, value)
                    }
                >
                    {renderQuestionsForDropdown(props.timeQuestionNodes)}
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={props.dateQuestionNodes.length ? '-' : 'No date questions'}
                    value={props.eventOpsEndDateNodeCode}
                    fullWidth
                    label={LABEL_END_DATE_QUESTION}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_END_DATE_NODE_CODE, value)
                    }
                >
                    {renderQuestionsForDropdown(props.dateQuestionNodes)}
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={props.timeQuestionNodes.length ? '-' : 'No time questions'}
                    value={props.eventOpsEndTimeNodeCode}
                    fullWidth
                    label={LABEL_END_TIME_QUESTION}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_END_TIME_NODE_CODE, value)
                    }
                >
                    {renderQuestionsForDropdown(props.timeQuestionNodes)}
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={props.allQuestionNodes.length ? '-' : 'No questions'}
                    value={props.eventOpsTimeZoneNodeCode}
                    fullWidth
                    label={LABEL_TIME_ZONE_QUESTION}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_TIME_ZONE_NODE_CODE, value)
                    }
                >
                    {renderQuestionsForDropdown(props.allQuestionNodes)}
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiDropdown
                    placeholder={props.allQuestionNodes.length ? '-' : 'No questions'}
                    value={props.eventOpsLocationNodeCode}
                    fullWidth
                    label={LABEL_LOCATION_QUESTION}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_LOCATION_NODE_CODE, value)
                    }
                >
                    {renderQuestionsForDropdown(props.allQuestionNodes)}
                </SuiDropdown>
            </SuiContainer>
            <SuiContainer variation="flex-group">
                <SuiTextInput
                    value={props.eventOpsWidgetUrl}
                    fullWidth
                    label={LABEL_WIDGET_URL}
                    onChange={(e, value) =>
                        props.updateFormNodeConfigValue(props.formNodeId, CONFIG_NAME_EVENT_OPS_WIDGET_URL, value)
                    }
                />
            </SuiContainer>
        </EditViewSectionContainer>
    </React.Fragment>
);

const propTypeQuestionNode = PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.label,
});

EventOps2EditView.propTypes = {
    formNodeId: PropTypes.string.isRequired,
    updateFormNodeConfigValue: PropTypes.func.isRequired,
    eventOpsClientId: PropTypes.string,
    eventOpsClientSecret: PropTypes.string,
    eventOpsCompanyToken: PropTypes.string,
    eventOpsStartDateNodeCode: PropTypes.string,
    eventOpsStartTimeNodeCode: PropTypes.string,
    eventOpsEndDateNodeCode: PropTypes.string,
    eventOpsEndTimeNodeCode: PropTypes.string,
    eventOpsTimeZoneNodeCode: PropTypes.string,
    eventOpsLocationNodeCode: PropTypes.string,
    eventOpsResourceType: PropTypes.string,
    eventOpsWidgetUrl: PropTypes.string,
    dateQuestionNodes: PropTypes.arrayOf(propTypeQuestionNode).isRequired,
    timeQuestionNodes: PropTypes.arrayOf(propTypeQuestionNode).isRequired,
    allQuestionNodes: PropTypes.arrayOf(propTypeQuestionNode).isRequired,
};

EventOps2EditView.defaultProps = {
    eventOpsClientId: '',
    eventOpsClientSecret: '',
    eventOpsCompanyToken: '',
    eventOpsStartDateNodeCode: undefined,
    eventOpsStartTimeNodeCode: undefined,
    eventOpsEndDateNodeCode: undefined,
    eventOpsEndTimeNodeCode: undefined,
    eventOpsTimeZoneNodeCode: undefined,
    eventOpsLocationNodeCode: undefined,
    eventOpsWidgetUrl: '',
    eventOpsResourceType: null,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const node = getEditFormNode(state);
    const formNodeId = getEditFormNodeId(state);

    return {
        formNodeId,
        name: node ? node.name : undefined,
        eventOpsClientId: node.config[CONFIG_NAME_EVENT_OPS_CLIENT_ID],
        eventOpsClientSecret: node.config[CONFIG_NAME_EVENT_OPS_CLIENT_SECRET],
        eventOpsCompanyToken: node.config[CONFIG_NAME_EVENT_OPS_COMPANY_TOKEN],
        eventOpsStartDateNodeCode: node.config[CONFIG_NAME_START_DATE_NODE_CODE],
        eventOpsStartTimeNodeCode: node.config[CONFIG_NAME_START_TIME_NODE_CODE],
        eventOpsEndDateNodeCode: node.config[CONFIG_NAME_END_DATE_NODE_CODE],
        eventOpsEndTimeNodeCode: node.config[CONFIG_NAME_END_TIME_NODE_CODE],
        eventOpsTimeZoneNodeCode: node.config[CONFIG_NAME_TIME_ZONE_NODE_CODE],
        eventOpsLocationNodeCode: node.config[CONFIG_NAME_LOCATION_NODE_CODE],
        eventOpsWidgetUrl: node.config[CONFIG_NAME_EVENT_OPS_WIDGET_URL],
        eventOpsResourceType: node.config[CONFIG_NAME_EVENT_OPS_RESOURCE_TYPE],
        dateQuestionNodes: getQuestionFormNodesOfInputType(state, formId, INPUT_TYPE_DATE),
        timeQuestionNodes: getQuestionFormNodesOfInputType(state, formId, INPUT_TYPE_TIME),
        allQuestionNodes: getQuestionFormNodes(state, formId),
    };
};

const mapDispatchToProps = {
    updateFormNodeConfigValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventOps2EditView);
